import { AlphabetsDraftApi, useAPIAction } from "melco-shared-logic";
import { ServiceType } from "../../../helper/serviceType";

export const useFontUpload = (service?: ServiceType) => {
  const [uploadFont] = useAPIAction(
    AlphabetsDraftApi,
    async (api, file: Blob) => {
      const data = await api.userAlphabetsUploadDraft({
        service,
        file,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "fonts.actions.upload",
    }
  );

  return {
    uploadFont,
  } as const;
};
